import React from 'react';
import { Link } from 'react-router-dom';

import cbcvLogo from '../assets/logo2016cuadrado_sinfondo.png';

const NotFoundPage = () => (
  <div className="not-found-wrapper">
    <img src={cbcvLogo} alt="Colegio Bilingue Ciudad Vieja Logo" />
    <h4> 404 Página no encontrada </h4>
    <Link to="/"> Volver al inicio </Link>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js